import React from 'react';
import './FunnelChart.scss';

const FunnelChart = ({
    data = [],
    height = 400,
    loading = false
}) => {
    if (loading) {
        return (
            <div className="chart-loading" style={{ height: `${height}px` }}>
                <div className="loading-skeleton"></div>
            </div>
        );
    }

    if (!data || data.length === 0) {
        return (
            <div className="chart-empty" style={{ height: `${height}px` }}>
                <p>No data available</p>
            </div>
        );
    }

    const maxValue = Math.max(...data.map(item => item.value));
    const minValue = Math.min(...data.map(item => item.value));

    return (
        <div className="funnel-chart-container">
            <div className="funnel-chart" style={{ height: `${height}px` }}>
                {data.map((item, index) => {
                    const widthPercent = ((item.value - minValue) / (maxValue - minValue)) * 60 + 40;
                    const prevValue = index > 0 ? data[index - 1].value : item.value;
                    const conversionRate = index > 0 ? ((item.value / prevValue) * 100).toFixed(1) : 100;
                    
                    return (
                        <div key={index} className="funnel-step">
                            <div className="funnel-bar-wrapper">
                                <div 
                                    className="funnel-bar"
                                    style={{ width: `${widthPercent}%` }}
                                >
                                    <div className="funnel-label">
                                        <span className="funnel-name">{item.name}</span>
                                        <span className="funnel-value">{item.value.toLocaleString()}</span>
                                    </div>
                                    {index > 0 && (
                                        <div className="funnel-conversion">
                                            {conversionRate}%
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default FunnelChart;


